import React from "react";
import BrowsersOSPieChart from "./BrowsersOSPieChart";
import BrowsersTypePieChart from "./BrowsersTypePieChart";
import BrowsersSystemPieChart from "./BrowsersSystemPieChart";
import BrowsersCityPieChart from "./BrowsersCityPieChart";
import BrowsersRegionPieChart from "./BrowsersRegionPieChart";
import BrowsersCountryPieChart from "./BrowsersCountryPieChart";

export default function BrowserData() {
  return (
    <>
      <div className="d-flex flex-column flex-lg-row justify-content-lg-around pb-2">
        <BrowsersTypePieChart />
        <BrowsersOSPieChart />
        <BrowsersSystemPieChart />
      </div>
      <div className="d-flex flex-column flex-lg-row justify-content-lg-around pb-2">
        <BrowsersCityPieChart />
        <BrowsersRegionPieChart />
        <BrowsersCountryPieChart />
      </div>
    </>
  );
}
